/**
 * Create store system ping
 *
 * @since 2018-07-09
 * @author jongsung.Lee(devp010)
 */

import {CommonApiPrefix as coApiPrefix} from 'utils'
// sm SystemApiPrefix

export const plugins = [Plugin]

export const state = () => ({
  apiUrlPath: {
    // ping
    apiCoPing: `${coApiPrefix}/tools/connect`
  }
})

export const mutations = {
}

export const actions = {
  async chkIpPing ({commit, state}, param) {
    const {code, result} = await this.$axios.$get(`${state.apiUrlPath['apiCoPing']}/${param.ip}`)
    if (code === 'ok' && result.connect !== undefined) {
      return result.connect === true
    } else {
      return false
    }
  }
}

export const getters = {
}

export const strict = false
